var _nSliderRangeMinValue = 1998;
var _nSliderRangeMaxValue = 2012;
var _nSliderValue = 2012;
var _initializingSlider = false;
var _addThisInit = false;
var rangeInit = false;
var sliderInit = false;
var sliderChange = true;
var existsShareHandles = false;
var _recent = 1;
var _strSelectedPivot = "Survey";

/*****************************************************************
function:   loadIndicators
Desc.:      Initialize and populate the list of indicators.
*****************************************************************/
var loadData = function() {
  //If the URL is requesting embed, hide the following divs.
  if (g_Embed) {
    //Hide divs not required.
    $("#embedHeader").hide();
    $("#embedFooter").hide();
    $("#embedBottomToolbarSizer").hide();
    $("#embedTopToolbar").hide();
    $("#drawer").hide();

    //Change CSS.
    $("#dataTableContainer").css("padding-top", 0);
  }

  exportsAutoCloseInit();
  optionsAutoCloseInit();
  $("#pageSizer").addClass("data");
  $("#pageSizer").addClass("header-data-view");
  $("#contentDiv").addClass("data-padding");
  checkMobilePreference();

  //Disable view buttons until data load
  var viewButtons = $(".topToolbar").find(
    ".iconTable, .iconBarChart, .iconLineChart, .iconMap"
  );
  viewButtons.prop("disabled", true);

  //Declare Important Variables.
  var displayType;
  var pivotType;
  var displayRecentSurveys;

  // Set correct drawer sizer type
  if (Modernizr.flexbox) {
    $("#drawerSizer").addClass("flexSizer");
  } else {
    $("#drawerSizer").addClass("staticSizer");
  }

  //Setup the footer correctly.
  $("#disclaimer").addClass("hidden");
  $("#metaDataInfo").removeClass("hidden");
  var arrDenominatorIndicators = arrSelectedDenominatorIndicators
    .map(function(objRow) {
      if (typeof objRow === "object") {
        var string =
          objRow.IndicatorSpecial1Id !== ""
            ? objRow.IndicatorSpecial1Id + ","
            : "";
        string +=
          objRow.IndicatorSpecial2Id !== ""
            ? objRow.IndicatorSpecial2Id + ","
            : "";
        string +=
          objRow.DenominatorWeightedId !== ""
            ? objRow.DenominatorWeightedId + ","
            : "";
        string +=
          objRow.IndicatorTotalId !== "" ? objRow.IndicatorTotalId + "," : "";
        string +=
          objRow.DenominatorUnweightedId !== ""
            ? objRow.DenominatorUnweightedId + ","
            : "";
        string +=
          objRow.DenominatorWeightedId !== ""
            ? objRow.DenominatorWeightedId
            : "";
        return string;
      } else {
        return objRow;
      }
    })
    .join(",");

  //Create new object.
  var objParams = {};
  objParams["countryIds"] = arrSelectedCountryCodes.join(",");

  // 	objParams["indicatorIds"] = arrSelectedIndicatorCodes.join(',') + ',' + arrDenominatorIndicators;
  objParams["indicatorIds"] = arrSelectedIndicatorCodes.join(",");
  objParams["indicatorIds"] = objParams["indicatorIds"].replace(/,,/g, ",");
  objParams["returnFields"] =
    "DataId,Indicator,SurveyId,IsPreferred,Value,SDRID,Precision,RegionId,SurveyYearLabel,SurveyType,SurveyYear,IndicatorOrder,DHS_CountryCode,CILow,CountryName,CharacteristicId,CharacteristicCategory,IndicatorId,CharacteristicOrder,CharacteristicLabel,ByVariableLabel,DenominatorUnweighted,DenominatorWeighted,CIHigh,IsTotal,ByVariableId,IndicatorType,IndicatorTotalId";
  if (objParams["countryIds"] === "" || objParams["countryIds"] === ",") {
    objParams["countryIds"] = getQueryVariable("cc");
    if (objParams["countryIds"].match(/all/i) !== null) {
      objParams["countryIds"] = window.globalAllCountriesFullResponse.Data.map(
        function(v) {
          return v.DHS_CountryCode;
        }
      ).join(",");
    }
  }

  if (objParams["indicatorIds"] === "" || objParams["indicatorIds"] === ",") {
    objParams["indicatorIds"] = getQueryVariable("ic");
  }
  //Make a call to obtain all the data.
  var retData = dhsAPI.getData(objParams, true, showLoader, hideLoader);
  var isDisabled = false;
  //Data Returned, parse the data to create the dashboard.
  retData.done(function(returnData) {
    //If data is successful. record in Analytics.
    var strLabel =
      "countryIds:" +
      objParams.countryIds +
      ";indicatorsIds:" +
      objParams.indicatorIds;
    if (window.ga) {
      ga("send", "event", "Query", "getData", strLabel);
    }
    if (window.gtag) {
      gtag("event", "getData", { event_label: "Query", event_value: strLabel });
    }
    //If no records were obtained, please advise user.
    if (returnData.Recordcount == 0) {
      $("#optionsMenu").css("opacity", ".25");
      document.getElementById("optionsButton").onclick = function() {
        return false;
      };
      $("#exportsMenu").css("opacity", ".25");
      document.getElementById("exportButton").onclick = function() {
        return false;
      };
      $("#shareButton").attr("disabled", true);
      isDisabled = true;
    } else {
      $("#optionsMenu").css("opacity", "1");
      document.getElementById("optionsButton").onclick = function() {
        $("#optionsMenu").toggleClass("open");
      };
      $("#exportsMenu").css("opacity", "1");
      //document.getElementById('exportButton').onclick = function(){$("#exportsMenu").toggleClass("open")};
      $("#shareButton").attr("disabled", false);
      isDisabled = false;
    }

    //First make sure Indicator data has been loaded.
    var nCurrentTry = 0;
    var nTries = 4;
    while (!bIndicatorDataLoaded && nCurrentTry < nTries) {
      sleep(1000);
      nCurrentTry++;
    }

    //Enable view buttons
    viewButtons.prop("disabled", false);

    //Assign data to global for sorting and pivoting.
    arrData = sort_by_props(returnData.Data, [
      "CountryName",
      "SurveyId",
      "CharacteristicOrder",
      "ByVariableId"
    ]);

    buildSlider();
    exportSliders();

    //Select Display Type.
    switch (g_nInitialDisplayType) {
      case 0:
        displayType = statCompilerDashboard.DISPLAY_TYPE.Grid;
        break;
      case 1:
        displayType = statCompilerDashboard.DISPLAY_TYPE.Column;
        break;
      case 2:
        displayType = statCompilerDashboard.DISPLAY_TYPE.Line;
        break;
      case 3:
        displayType = statCompilerDashboard.DISPLAY_TYPE.ScatterPlot;
        break;
      case 4:
        displayType = statCompilerDashboard.DISPLAY_TYPE.Map;
        break;
      default:
        displayType = statCompilerDashboard.DISPLAY_TYPE.Grid;
        break;
    }

    //Select Pivot Type.
    switch (g_nInitialPivotType) {
      case 0:
        pivotType = statCompilerDashboard.PIVOT_TYPE.Survey;
        break;
      case 1:
        pivotType = statCompilerDashboard.PIVOT_TYPE.Indicator;
        break;
      case 2:
        pivotType = statCompilerDashboard.PIVOT_TYPE.SurveyChar;
        break;
      case 3:
        pivotType = statCompilerDashboard.PIVOT_TYPE.CharSurvey;
        break;
      default:
        pivotType = statCompilerDashboard.PIVOT_TYPE.Survey;
        break;
    }

    //Display Data on a grid.
    statCompilerDashboard.initializeDashboard(
      "#gridDATA",
      "#charts",
      "#lstIndicators",
      "#mapDiv",
      "#mapControls",
      "#lstCharLabels",
      "#lstCountries",
      "#selectPivot",
      arrData,
      g_arrCheckedCharLabels,
      g_arrCheckedCountryCodes,
      pivotType,
      displayType,
      g_nMapLevelRank,
      g_strBreakType,
      g_arrCustomBreaks,
      g_bCustBrksFromShare
    );
    setDisplay(displayType, false);

    //Set the Pivot drop down correctly.
    $("#movileSelectPivot").val(pivotType);

    //Update the surveys depending on survey selection. All is default, so do not call that.
    switch (g_strSurveySelection) {
      case statCompilerDashboard.SURVEY_SELECTION.Recent:
        statCompilerDashboard.displayRecentSurveys(false, 1);
        $("#viewRecentSurveys").addClass("selected");
        $("#toggleMostRecent").addClass("selected");
        $("#viewAllSurveys").removeClass("selected");
        $("#sliderButton").removeClass("selected");
        break;
      case statCompilerDashboard.SURVEY_SELECTION.Custom:
        setTimeout(() => {
          statCompilerDashboard.displayCustomSurveySelector(
            g_arrSharedUnselectedSurveys,
            false
          );
        }, 500);

        $("#viewRecentSurveys").removeClass("selected");
        $("#toggleMostRecent").removeClass("selected");
        $("#viewAllSurveys").removeClass("selected");
        $("#sliderButton").addClass("selected");
        break;
    }

    //This is a workaround for when removing all traces of the popups.
    if ($(".popupGrabber").length) {
      $(".popupGrabber").remove();
    }

    // This call to refresh was commented out below. I'm adding it back because it's
    // displaying the current selected indicator in the sidebar. Added a check to be sure that the element has been instantiated
    // by the jQuery plugin. This should instead be done in a place that is guaranteed that it will be so.

    if (
      typeof $("#lstIndicators").indicatorselectmenu === "function" &&
      $("#lstIndicators").indicatorselectmenu("instance").ids
    ) {
      try {
        $("#lstIndicators").indicatorselectmenu("refresh");
      } catch (error) {}
    }
    // updateSlider("",true);

    var shareContainer = $("#shareContainer");
    shareContainer.click(function(evt) {
      var isClickOnWhitespace =
        evt.target == this || evt.target == $("#atstbx")[0];
      if (isClickOnWhitespace) {
        shareContainer.removeClass("open");
        $("#bookmarkContainer").removeClass("open");
      }
    });

    //Open the drawer initially.
    $(".mobileActionList").removeClass("hidden");
    $(".actionList").removeClass("hidden");
    $("#legendContainer").removeClass("hidden");
    var selectmenuFunc = isDisabled === true ? "disable" : "enable";
  }); //END retIndicators.done(...

  //Handle Errors.
  retData.fail(function(value) {});

  $(".current_byvariable_string").text($("#byVariableSelect").val());

  $(document).on("change", "#byVariableSelect", function(e, ui) {
    var val = $("#byVariableSelect").val();

    onChangeByVariableLabel(val);
  });

  $(".pivot").on("click", function(evt) {
    $(this)
      .parent()
      .find(".pivot")
      .removeClass("selected");

    evt.currentTarget.classList.add("selected");
    var selectedValue = evt.currentTarget.dataset.value;
    _strSelectedPivot = selectedValue;
    onChangePivot(selectedValue);
  });

  $(
    "#DenominatorOption1, #DenominatorOption2, #SpecialOption1, #TotalOption1"
  ).on("click", function(evt) {
    $("#" + evt.currentTarget.id + " button").toggleClass("checked");
    $("#" + evt.currentTarget.id + " button").toggleClass("unchecked");
    var bDisplayWeightedDenominators,
      bDisplayUnweightedDenominators,
      bDisplayTotals,
      bDisplaySpecailIndicators,
      bDisplaySpecailIndicatorsClicked = false;

    //Depending on the button clicked, checked whether the button was checked or unchecked.
    if (evt.currentTarget.id === "DenominatorOption1") {
      bDisplayWeightedDenominators = $("#DenominatorOption1 button").hasClass(
        "checked"
      )
        ? true
        : false;
    } else if (evt.currentTarget.id === "DenominatorOption2") {
      bDisplayUnweightedDenominators = $("#DenominatorOption2 button").hasClass(
        "checked"
      )
        ? true
        : false;
    } else if (evt.currentTarget.id === "SpecialOption1") {
      bDisplaySpecailIndicatorsClicked = true;
      bDisplaySpecailIndicators = $("#SpecialOption1 button").hasClass(
        "checked"
      )
        ? true
        : false;
    } else if (evt.currentTarget.id === "TotalOption1") {
      bDisplayTotals = $("#TotalOption1 button").hasClass("checked")
        ? true
        : false;
    }

    //Put up the loader
    showLoader();

    //Update the Denominator Booleans.
    statCompilerDashboard.updateDenominatorBoolenas(
      bDisplayWeightedDenominators,
      bDisplayUnweightedDenominators,
      bDisplayTotals,
      bDisplaySpecailIndicators,
      bDisplaySpecailIndicatorsClicked
    );

    //Load the Data (This will only load extra data if it is needed)
    if (
      bDisplayWeightedDenominators ||
      bDisplayUnweightedDenominators ||
      bDisplayTotals ||
      bDisplaySpecailIndicators
    ) {
      AppendAPIData("Indicators", [], true);
    } else {
      hideLoader();
      onChangePivot(_strSelectedPivot);
    }
  });

  $("#mobileSelectPivot").selectmenu();
  $("#mobileSelectPivot")
    .selectmenu("widget")
    .addClass("jQuerySelectButton solid");
  $("#mobileSelectPivot")
    .selectmenu("menuWidget")
    .addClass("jQuerySelectMenu solid");
  $("#mobileSelectPivot").on("selectmenuchange", function(e, ui) {
    onChangePivot(ui);
  });

  $.widget(
    "ui.indicatorselectmenu",
    $.extend({}, $.ui.selectmenu.prototype, {
      _init: function() {
        this.element.data(
          "selectmenu",
          this.element.data("indicatorselectmenu")
        );
        return $.ui.selectmenu.prototype._init.apply(this, arguments);
      },

      // Override other methods here.
      _renderItem: function(ul, item) {
        var li = $("<li>").css("background-color", item.value);
        li.append(
          "<span class='liText'>" +
            item.label +
            "</span><button class='iconInfo' onclick='addParametersPopup(\"#parameterPopup2\",\"metadata\",false)'></button>"
        );
        return li.appendTo(ul);
      }
    })
  );

  $.ui.indicatorselectmenu.defaults = $.extend({}, $.ui.selectmenu.defaults);

  $("#lstIndicators").on("selectmenucreate", function(e, ui) {
    var parentNode = $("#lstIndicators").indicatorselectmenu("widget")[0]
      .parentNode;

    $(parentNode).append('<div class="pseudoButton iconInfo"></div>');

    $(parentNode)
      .find(".pseudoButton.iconInfo")
      .on("click", function() {
        const selectedIndicatorCode = statCompilerDashboard.getSelectedIndicatorCode();
        const selectedIndicator = statCompilerDashboard.getSelectedIndicator();

        showIndicatorMetaDataInfo(selectedIndicator, selectedIndicatorCode);
      });
  });

  $("#lstIndicators").indicatorselectmenu();
  $("#lstIndicators")
    .indicatorselectmenu("widget")
    .addClass("jQuerySelectButton hollow");
  $("#lstIndicators")
    .indicatorselectmenu("menuWidget")
    .addClass("jQuerySelectMenu hollow");

  $("#lstIndicators").on("selectmenuchange", function(e, ui) {
    onChangeIndicator(false);
    //Adding refresh to refresh the UI.
    $("#lstIndicators").indicatorselectmenu("refresh");
  });
  if ($("#lstIndicators")[0].children.length > 0) {
    $("#lstIndicators").indicatorselectmenu("refresh");
  }

  // Storing the order into which the checkboxes are checked
  $(".indicatorsTreeDiv").on("select_node.jstree", function(evt, data) {
    statCompilerDashboard.getSelectedIndicatorDropdown();
    _selectedIndicatorDropdown.push(data.node.text);
  });

  $(".indicatorsTreeDiv").on("deselect_node.jstree", function(evt, data) {
    _.pull(_selectedIndicatorDropdown, data.node.text);
  });
};

var onChangePivot = function(selectedValue) {
  if (selectedValue == statCompilerDashboard.PIVOT_TYPE.Survey) {
    statCompilerDashboard.updatePivot(statCompilerDashboard.PIVOT_TYPE.Survey);
  } else if (selectedValue == statCompilerDashboard.PIVOT_TYPE.Indicator) {
    statCompilerDashboard.updatePivot(
      statCompilerDashboard.PIVOT_TYPE.Indicator
    );
  } else if (selectedValue == statCompilerDashboard.PIVOT_TYPE.SurveyChar) {
    statCompilerDashboard.updatePivot(
      statCompilerDashboard.PIVOT_TYPE.SurveyChar
    );
  } else if (selectedValue == statCompilerDashboard.PIVOT_TYPE.CharSurvey) {
    statCompilerDashboard.updatePivot(
      statCompilerDashboard.PIVOT_TYPE.CharSurvey
    );
  }
};

var showIndicatorMetaDataInfo = function(indicatorName, indicatorId, event) {
  if (indicatorId) {
    statCompilerDashboard.updateInfoIndicator(indicatorName, indicatorId);
  }

  addParametersPopup(
    "#parameterPopup2",
    "metadata",
    false,
    Config.getUniversalString("indicatorPopupTitle")
  );
  //TODO: commented out test if is blocking the popup
  if (event) {
    event.preventDefault();
    event.stopPropagation();
    ie8SafePreventEvent(event);
  }
  return false;
};

function ie8SafePreventEvent(e) {
  if (e.preventDefault) {
    e.preventDefault();
  } else {
    e.stop();
  }

  e.returnValue = false;
  e.stopPropagation();
}

var showBreaksInfo = function(indicatorName) {
  addParametersPopup(
    "#parameterPopup2",
    "breaks",
    false,
    Config.getUniversalString("breaks")
  );
};

const showCustomBreaksInfo = () => {
  addParametersPopup(
    "#parameterPopup2",
    "customBreaks",
    false,
    Config.getUniversalString("customBreakTitle")
  );
};

/*****************************************************************
function:   checkMobilePreference
Desc.:      show helper popup if mobile
return:     void
*****************************************************************/
var checkMobilePreference = function() {
  if (
    window.mobileDetect &&
    window.mobileDetect.mobile() &&
    !localStorage.getItem("remember")
  ) {
    addParametersPopup(
      "#parameterPopup2",
      "mobileDetect",
      false,
      "Mobile Detected"
    );
  }
};

/*****************************************************************
function:   toggleControlPanel
Desc.:      Function to help toggle the control panel.
return:     Display/Hide the control panel.
*****************************************************************/
var toggleDrawer = function() {
  // $(".dataContent").toggleClass("sideContentOpen");
  $(".data").toggleClass("drawerOpen");
  // Set a small timeout to ensure width has settled through animation
  setTimeout(function() {
    statCompilerDashboard.displayData(
      statCompilerDashboard.getCurrentDisplayType()
    );
    toggleGuidedHelp(statCompilerDashboard.getCurrentDisplayType());
  }, 750);
};

var toggleGuidedHelp = function(currDisplay) {
  if (
    localStorage.getItem("startedTour_grid") === "true" &&
    currDisplay == "Grid"
  ) {
    statCompilerDashboard.startTourGrid();
    localStorage.setItem("startedTour_grid", false);
  }
  if (
    localStorage.getItem("startedTour_col") === "true" &&
    currDisplay == "Col"
  ) {
    statCompilerDashboard.startTourGrid();
    localStorage.setItem("startedTour_col", false);
  }
  if (
    localStorage.getItem("startedTour_line") === "true" &&
    currDisplay == "Line"
  ) {
    statCompilerDashboard.startTourGrid();
    localStorage.setItem("startedTour_line", false);
  }
};

/*****************************************************************
function:   toggleGridLines
Desc.:      Function to help toggle the grid lines on a chart.
return:     Display/Hide the grid lines.
*****************************************************************/
var toggleGridLines = function() {
  if (statCompilerDashboard.toggleGridLines()) {
    $("#disableGrid").removeClass("unchecked");
    $("#disableGrid").addClass("checked");
  } else {
    $("#disableGrid").removeClass("checked");
    $("#disableGrid").addClass("unchecked");
  }
};

/*****************************************************************
function:   toggleYAxisLabel
Desc.:      Function to help toggle the YAxis Labels
return:     Display/Hide the Y Axis.
*****************************************************************/
var toggleYAxisLabel = function() {
  if (statCompilerDashboard.toggleYAxisLabel()) {
    $("#hideYAxis").removeClass("unchecked");
    $("#hideYAxis").addClass("checked");
  } else {
    $("#hideYAxis").removeClass("checked");
    $("#hideYAxis").addClass("unchecked");
  }
};

/*****************************************************************
function:   toggleLegend
Desc.:      Function to help toggle the Legend.
return:     Display/Hide the Legend.
*****************************************************************/
var toggleLegend = function() {
  if (statCompilerDashboard.toggleLegend()) {
    $("#hideLabels").removeClass("unchecked");
    $("#hideLabels").addClass("checked");
  } else {
    $("#hideLabels").removeClass("checked");
    $("#hideLabels").addClass("unchecked");
  }
};

/*****************************************************************
function:   toggleYToMaxPercent
Desc.:      Function to help toggle the Y-Axis 100% option.
return:     Display/Hide the Y-Axis 100% option.
*****************************************************************/
var toggleYToMaxPercent = function() {
  if (statCompilerDashboard.toggleYToMaxPercent()) {
    $("#setYToMaxPercent").removeClass("unchecked");
    $("#setYToMaxPercent").addClass("checked");
  } else {
    $("#setYToMaxPercent").removeClass("checked");
    $("#setYToMaxPercent").addClass("unchecked");
  }
};

/*****************************************************************
function:   toggleDataPoints
Desc.:      Function to help toggle the Data Points.
return:     Display/Hide the Data Points.
*****************************************************************/
var toggleDataPoints = function() {
  if (statCompilerDashboard.toggleDataPoints()) {
    $("#hideDataPoints").removeClass("unchecked");
    $("#hideDataPoints").addClass("checked");
  } else {
    $("#hideDataPoints").removeClass("checked");
    $("#hideDataPoints").addClass("unchecked");
  }
};

/*****************************************************************
function:   toggleConfidenceIntervals
Desc.:      Function to help toggle the Confidence Intervals.
return:     Display/Hide the Confidence Interval error bars.
*****************************************************************/
var toggleConfidenceIntervals = function() {
  if (statCompilerDashboard.toggleConfidenceIntervals()) {
    $("#toggleConfidenceIntervals").removeClass("unchecked");
    $("#toggleConfidenceIntervals").addClass("checked");
  } else {
    $("#toggleConfidenceIntervals").removeClass("checked");
    $("#toggleConfidenceIntervals").addClass("unchecked");
  }
};

/*****************************************************************
function:   onChangeIndicator
Desc.:      Function to update indicator when you select a
            different indicator.
return:     change indicator and update conrtrols accordingly.
*****************************************************************/
var onChangeIndicator = function(updateList) {
  //Update the selected indicator.

  var values = $("#lstIndicators")
    .val()
    .split("|");

  statCompilerDashboard.updateSelectedIndicator(values[0], values[1]);

  //Update the Dashboard.
  statCompilerDashboard.updateDashboard(null, true); // should be false?
};

/*****************************************************************
function:   onChangeByVariableLabel
Desc.:      Function to update data when you select a
            different By Variable Label.
return:     change By Variable Label and update conrtrols accordingly.
*****************************************************************/
var onChangeByVariableLabel = function(val) {
  // Get selected value
  var val = val || $("#byVariableSelect").val();

  // Get all items on byVariableState
  const byVariableStateItems = byVariableState.items;

  // Update current by variable for all indicators on byVariableState that share
  // the selected by variable, otherwise leave unchanged
  for (let item in byVariableStateItems) {
    if (byVariableStateItems[item].all.includes(...val)) {
      byVariableStateItems[item].current = val;
    }
  }

  //Update the Dashboard.
  statCompilerDashboard.updateDashboard(null, true);
};

/*****************************************************************
function:   viewRecentSurveys
Desc.:      Function to view only the most recent surveys.
return:     void
*****************************************************************/
var viewRecentSurveys = function(value) {
  hideSlider();
  var number = value === "default" ? _recent : value;
  _recent = number;
  statCompilerDashboard.displayRecentSurveys(false, number);

  $("#viewRecentSurveys").addClass("selected");
  $("#toggleMostRecent").addClass("selected");
  $("#viewAllSurveys").removeClass("selected");
  $("#sliderButton").removeClass("selected");

  if (value === 1) {
    $("#viewRecentSurveysOne").addClass("selected");
    $("#viewRecentSurveysTwo").removeClass("selected");
  }
  if (value === 2) {
    $("#viewRecentSurveysOne").removeClass("selected");
    $("#viewRecentSurveysTwo").addClass("selected");
  }

  if ($("#viewRecentSurveysOne").hasClass("noWidth")) {
    $("#toggleMostRecent").removeClass("closed");
  }
};

var toggleMostRecent = function() {
  $("#viewRecentSurveys").addClass("selected");
  $("#viewAllSurveys").removeClass("selected");
  $("#sliderButton").removeClass("selected");
  $("#sliderContainer").addClass("hidden");

  $("#toggleMostRecent").addClass("selected");
  if ($("#viewRecentSurveysOne").hasClass("noWidth")) {
    $("#viewRecentSurveysOne").removeClass("noWidth");
    $("#viewRecentSurveysTwo").removeClass("noWidth");
    $("#viewRecentSurveys").removeClass("closed");
    $("#toggleMostRecent").addClass("closed");
  } else {
    $("#viewRecentSurveysOne").addClass("noWidth");
    $("#viewRecentSurveysTwo").addClass("noWidth");
    $("#viewRecentSurveys").addClass("closed");
    $("#toggleMostRecent").removeClass("closed");
  }

  statCompilerDashboard.displayRecentSurveys(false, _recent);
};

/*****************************************************************
function:   viewAllSurveys
Desc.:      Function to view all the surveys.
return:     void
*****************************************************************/
var viewAllSurveys = function(currDisplayType) {
  $("#viewRecentSurveysOne").addClass("noWidth");
  $("#viewRecentSurveysTwo").addClass("noWidth");
  // hideSlider();
  statCompilerDashboard.displayAllSurveys(undefined, currDisplayType);

  $("#viewAllSurveys").addClass("selected");
  $("#viewRecentSurveys").removeClass("selected");
  $("#toggleMostRecent").removeClass("selected");
  $("#sliderButton").removeClass("selected");
};

/*****************************************************************
function:   toggleShareWidget
Desc.:      Function to obtain a bookmark for the current app
            state.
return:     void
*****************************************************************/
var toggleShareWidget = function() {
  updateShareURL();
  if (!existsShareHandles) {
    addShareHandles();
  }
  $("#shareContainer").toggleClass("hidden");
  $("#shareButton").toggleClass("open");
  $("#shareContainer").toggleClass("open");
  $("#bookmarkContainer").removeClass("open");
};

var attemptCloseShareWidget = function(evt) {
  console.debug(evt);
};

var addShareHandles = function() {
  $("#atstbx .at-share-btn").click(function() {
    toggleShareWidget();
  });
  existsShareHandles = true;
};

/*****************************************************************
function:   openShare
Desc.:      Function to open share dialog.
return:     void
*****************************************************************/
var openShare = function() {
  //alert("bookmark")
  $("#mobileExportsMenu").removeClass("open");
  $("#exportsMenu").removeClass("open");
  $("#optionsMenu").removeClass("open");
  $("#mobileOptionsMenu").removeClass("open");

  if (!_addThisInit) {
    addParametersPopup(
      "#sharePopup",
      "bookmark",
      false,
      Config.getUniversalString("share")
    );
    addThisInit();
    _addThisInit = true;
  } else {
    updateBookmark();
    updateShareURL();
    updateAddThis();

    $("#sharePopup").dialog("open");
  }
};

/*****************************************************************
function:   closeError
Desc.:      Function to close error dialog if for customPopup.
return:     void
*****************************************************************/
var closeError = function() {
  $("#sharePopup").dialog("close");
};

var toggleExport = function() {
  var selectPivotButton = $("#selectPivot");
  $("#exportsMenu").toggleClass("open");
  // Making sure the options menu closes
  if (selectPivotButton.hasClass("open")) {
    $("#selectPivot").toggleClass("open");
  }
  setTimeout(function() {
    $("<style></style>")
      .appendTo($(document.body))
      .remove(); // fix for safari being stupid
  });
};

/*****************************************************************
function:   closeShare
Desc.:      Function to close share dialog.
return:     void
*****************************************************************/

var closeShare = function() {
  $("#sharePopup").dialog("close");
  $(".popup .caption").empty();
  $(".popup .caption").append(
    '<div class="caption" id="copyLinkToShare">Copy the link to share<br><span id="copyInstructions">(Ctrl+C on PC or Cmd+C on Mac)</span></div>'
  );
  $(".popup .caption").removeClass("success");
};
/*****************************************************************
function:   copyBookmark
Desc.:      Function to copy bookmark link to clipboard.
return:     void
*****************************************************************/

const copyBookmark = function() {
  const bookmarkUrl = $("#bookmarkText").val();
  navigator.clipboard
    .writeText(bookmarkUrl)
    .then(() => {
      setTimeout(function() {
        $(".popup .caption").html("Copied successfully &#10003");
        $(".popup .caption").addClass("success");
        $(".popup button.tile.green").focus();
      }, 100);
    })
    .catch(err => {
      console.error(err);
    });
};

/*****************************************************************
function:   getBookmark
Desc.:      Function to open/refresh bookmark
            state.
return:     void
*****************************************************************/

var getBookmark = function() {
  //alert("bookmark")
  //addParametersPopup("#parameterPopup2", "bookmark", false, "Share URL");
  showBookmark();
};

/*****************************************************************
function:   updateBookmark
Desc.:      Function to open/refresh bookmark
            state.
return:     void
*****************************************************************/
var updateBookmark = function() {
  // var bitly = statCompilerDashboard.getBookmark(document.URL);
  // $('#bookmarkText').text(statCompilerDashboard.getBookmark(document.URL));
  $("#bookmarkText").val(statCompilerDashboard.getBookmark(document.URL));
  $("#bookmarkContainer").addClass("open");
  $("#bookmarkText");
};

/*****************************************************************
function:   closeBookmark
Desc.:      Function to close boomark
            state.
return:     void
*****************************************************************/
var closeBookmark = function() {
  $("#bookmarkContainer").removeClass("open");
};

/*****************************************************************
function:   facebookShareClicked
Desc.:      Function the response to when the facebook button is clicked in the share icon,
            this handles are the responsibility of refreshing the url and generating the
            bitly url as well.
return:     void
*****************************************************************/
var facebookShareClicked = function() {
  var text = "Placeholder text, statcompiler";
  // window.open("https://www.facebook.com/sharer/sharer.php?s=100&p[title]=" + encodeURIComponent("This is a sample text") + "&p[url]=http://bit.ly/1CSdlO9","facebookShareDialog","width=626,height=436");
  return false;
};

/*****************************************************************
function:   TwitterShareClicked
Desc.:      Function the response to when the twitter button is clicked in the share icon,
            this handles are the responsibility of refreshing the url and generating the
            bitly url as well.
return:     void
*****************************************************************/
var twitterShareClicked = function() {};

/*****************************************************************
function:   toogleSidepanel
Desc.:      Toggles the side panel between open and close state
return:     void
*****************************************************************/
var toggleDrawerPanelState = function(toggleClassName) {
  var drawer = $("#drawer");
  drawer.toggleClass(toggleClassName);

  return;

  var displayType = statCompilerDashboard.getCurrentDisplayType();

  var indicatorsPanel = $("#indicatorsPanel");
  var countriesPanel = $("#countriesPanel");
  var mapPanel = $("#mapPanel");

  var indicatorsPanelClosed = indicatorsPanel.hasClass("closed");
  var indicatorsPanelHalfHeight = indicatorsPanel.hasClass("halfHeight");
  // var indicatorsPanelFixedHeight = indicatorsPanel.hasClass("fixedHeight");
  var countriesPanelClosed = countriesPanel.hasClass("closed");
  var countriesPanelHalfHeight = countriesPanel.hasClass("halfHeight");

  switch (panelType) {
    case "indicators":
      if (displayType != "Map") {
        if (indicatorsPanelClosed) {
          if (countriesPanelClosed) {
            indicatorsPanel.removeClass("closed");
          } else {
            indicatorsPanel.addClass("halfHeight");
            countriesPanel.addClass("halfHeight");
            indicatorsPanel.removeClass("closed");
          }
        } else {
          if (countriesPanelClosed) {
            indicatorsPanel.addClass("closed");
          } else {
            indicatorsPanel.removeClass("halfHeight");
            countriesPanel.removeClass("halfHeight");
            indicatorsPanel.addClass("closed");
          }
        }
      } else {
        indicatorsPanel.toggleClass("closed");
      }

      break;

    case "countries":
      if (displayType != "Map") {
        if (countriesPanelClosed) {
          if (indicatorsPanelClosed) {
            indicatorsPanel.addClass("closed");
            countriesPanel.removeClass("closed");
          } else {
            indicatorsPanel.addClass("halfHeight");
            countriesPanel.addClass("halfHeight");
            countriesPanel.removeClass("closed");
          }
        } else {
          indicatorsPanel.removeClass("halfHeight");
          countriesPanel.removeClass("halfHeight");
          countriesPanel.addClass("closed");
        }
      } else {
        countriesPanel.toggleClass("closed");
      }

      break;
    case "map":
      if (displayType != "Map") {
        return;
      } else {
        mapPanel.toggleClass("closed");
      }

      break;
  }

  indicatorsPanelClosed = indicatorsPanel.hasClass("closed");
  countriesPanelClosed = countriesPanel.hasClass("closed");

  if (displayType == "Map") {
    if (indicatorsPanelClosed || countriesPanelClosed) {
      indicatorsPanel.removeClass("halfHeight");
      countriesPanel.removeClass("halfHeight");
    } else if (!indicatorsPanelClosed && !countriesPanelClosed) {
      indicatorsPanel.addClass("halfHeight");
      countriesPanel.addClass("halfHeight");
    }
  }
};

/*****************************************************************
function:   toggleDiscreteLoader
Desc.:
return:     void
*****************************************************************/
var toggleDiscreteLoader = function() {
  var isLoading = $("dataView").hasClass("unloaded");

  if (isLoading) {
    $(".dataView").removeClass("unloaded discrete");
  } else {
    // $(".dataView").addClass("unloaded discrete");
  }
};

/*****************************************************************
function:   setDisplay
Desc.:      Sets the current data display & resolves drawer
            styling.
return:     void
*****************************************************************/
var setDisplay = function(displayType, updateDisplay) {
  var drawer = $(".drawer");
  var mapPanel = $("#mapPanel");
  var indicatorsPanel = $("#indicatorsPanel");
  var countriesPanel = $("#countriesPanel");

  var isMapPanelClosed = mapPanel.hasClass("closed");
  var isMapPanelHidden = mapPanel.hasClass("hidden");
  var isIndicatorPanelClosed = indicatorsPanel.hasClass("closed");
  var isIndicatorPanelHalfHeight = indicatorsPanel.hasClass("halfHeight");
  var isCountriesPanelClosed = countriesPanel.hasClass("closed");

  statCompilerDashboard.setCurrentDisplayType(displayType);

  // Handle toggling classes for views
  if (displayType != "Map") {
    drawer.removeClass("mapDisplay");

    if (!isMapPanelHidden) mapPanel.addClass("hidden");
    if (!isCountriesPanelClosed && !isIndicatorPanelClosed) {
      indicatorsPanel.addClass("halfHeight");
      countriesPanel.addClass("halfHeight");
    }
  } else {
    drawer.addClass("mapDisplay");

    if (isMapPanelHidden) mapPanel.removeClass("hidden");
  }

  if (updateDisplay) {
    //If Selecting Line chart, and survey selection is recent, switch to all.
    if (
      displayType == statCompilerDashboard.DISPLAY_TYPE.Line &&
      statCompilerDashboard.getCurrentSurveySelection() ==
        statCompilerDashboard.SURVEY_SELECTION.Recent
    ) {
      viewAllSurveys(displayType);
    } else if (
      displayType == statCompilerDashboard.DISPLAY_TYPE.Map &&
      statCompilerDashboard.getCurrentSurveySelection() ==
        statCompilerDashboard.SURVEY_SELECTION.All
    ) {
      viewRecentSurveys(1);
    } else if (
      displayType == statCompilerDashboard.DISPLAY_TYPE.Map &&
      statCompilerDashboard.getCurrentSurveySelection() ==
        statCompilerDashboard.SURVEY_SELECTION.Custom
    ) {
      // customTable.setGrid();
      checkGrid();
    }
    statCompilerDashboard.displayData(displayType);
  }

  updateSlider(displayType, false);

  // if(localStorage.getItem('startedGuidedHelp') === 'true') {
  //     statCompilerDashboard.setGuidedHelpCookies();
  // }
};

/*****************************************************************
function:   showDiscreteLoader
Desc.:      Shows discrete loader, optional text, default none
return:     void
*****************************************************************/

var showDiscreteLoader = function(message) {
  if (message == undefined) message = "";
  $('#discreteLoaderText').text(message);
  $('#dataTableContainer').addClass('unloaded discrete');
};

/*****************************************************************
function:   hideDiscreteLoader
Desc.:      Hides discrete loader clears text
return:     void
*****************************************************************/

var hideDiscreteLoader = function() {
  $("#dataTableContainer").removeClass("unloaded discrete");
  $("#discreteLoaderText").text("");
};

/*****************************************************************
function:   showLoader
Desc.:      Shows loader, optional text, default none
return:     void
*****************************************************************/

var showLoader = function(message) {
  if (message == undefined) message = "";
  $('#loaderText').text(message);
  $('#dataTableContainer').addClass('unloaded');
};

/*****************************************************************
function:   hideLoader
Desc.:      Hides loader clears text
return:     void
*****************************************************************/
var hideLoader = function() {
  $("#dataTableContainer").removeClass("unloaded");
  $("#loaderText").text("");
};

var optionsAutoCloseInit = function() {
  $(document).bind("click.optionsMenuAutoClose", function(event) {
    var isMenuButtonClick = $.inArray(event.target, $("#optionsMenu *")) != -1;
    if (!isMenuButtonClick) {
      $("#optionsMenu").removeClass("open");
    }
  });

  $(document).bind("click.optionsMenuAutoClose", function(event) {
    var isMenuButtonClick =
      $.inArray(event.target, $("#mobileOptionsMenu *")) != -1;
    if (!isMenuButtonClick) {
      $("#mobileOptionsMenu").removeClass("open");
    }
  });

  $(document).bind("click.selectPivotAutoClose", function(event) {
    var isMenuButtonClick = $.inArray(event.target, $("#selectPivot")) != -1;
    if (!isMenuButtonClick) {
      $("#selectPivot").removeClass("open");
    }
  });
};

var exportsAutoCloseInit = function() {
  $(document).bind("click.exportsMenuAutoClose", function(event) {
    var isMenuButtonClick =
      $.inArray(
        event.target,
        $("#exportsMenu .menu button, #exportsMenu .pseudoButton")
      ) != -1;
    if (!isMenuButtonClick) {
      $("#exportsMenu").removeClass("open");
    }
  });
};

var toggleSlider = function() {
  //$("#customSurveyDialog").removeClass('hidden');
  $(".popupParent").removeClass("hidden");
  if (!$("#sliderButton").hasClass("selected")) {
    $("#viewRecentSurveysOne").addClass("noWidth");
    $("#viewRecentSurveysTwo").addClass("noWidth");
    $("#viewAllSurveys").removeClass("selected");
    $("#viewRecentSurveys").removeClass("selected");
    $("#toggleMostRecent").removeClass("selected");
    $("#sliderButton").addClass("selected");
  }
};

var hideSlider = function() {
  $("#sliderContainer").addClass("hidden");
  $("#sliderButton")
    .removeClass("checked")
    .addClass("unchecked");
};

var buildSlider = function() {
  $("#slider").labeledslider({
    max: 2012,
    min: 1994,
    tickinterval: 1,
    slide: function(event, ui) {
      var firstIndex;
      $(".ui-slider-label-ticks span").each(function(index, domElement) {
        var htmlValue = parseInt(domElement.innerHTML);
        if (statCompilerDashboard.getCurrentDisplayType() != "Line") {
          if (htmlValue === ui.value) {
            $(".ui-slider-label-ticks").each(function(
              labelIndex,
              labelElement
            ) {
              if (index == labelIndex) {
                $(labelElement).addClass("showYear");
              } else {
                $(labelElement).removeClass("showYear");
              }
            });
          }
        } else {
          if (
            htmlValue === ui.value ||
            htmlValue === ui.values[0] ||
            htmlValue === ui.values[1]
          ) {
            $(".ui-slider-label-ticks").each(function(
              labelIndex,
              labelElement
            ) {
              if (htmlValue === ui.values[0]) {
                firstIndex = index;
              }
              if (index === labelIndex) {
                $(labelElement).addClass("showYear");
              } else if (labelIndex === firstIndex) {
                $(labelElement).addClass("showYear");
              } else {
                $(labelElement).removeClass("showYear");
              }
            });
          }
        }
      });
    },
    change: function(event, ui) {
      if (!_initializingSlider) {
        if (!$("#sliderContainer").hasClass("hidden")) {
          if (statCompilerDashboard.getCurrentDisplayType() != "Line") {
            _nSliderValue = ui.value;
            statCompilerDashboard.displayCustomSurvey(ui.value);
          } else {
            _nSliderRangeMinValue = ui.values[0];
            _nSliderValue = ui.values[1];
            // TIMCHANGE _nSliderRangeMaxValue = ui.values[1];
            statCompilerDashboard.displayCustomSurveyRange(
              ui.values[0],
              ui.values[1]
            );
          }
        }
      }
    }
  });
  setTimeout(function() {
    var objRange = statCompilerDashboard.getSurveyRange();
    _nSliderRangeMinValue = objRange.min;
    _nSliderRangeMaxValue = objRange.max;
    // _nSliderValue = ui.value;
    updateSlider(statCompilerDashboard.getCurrentDisplayType(), false);
  }, 1000);
};

var updateSlider = function(displayType, init) {
  var objRange = statCompilerDashboard.getSurveyRange();
  $("#slider").labeledslider("option", "max", objRange.max);
  $("#slider").labeledslider("option", "min", objRange.min);
  if (displayType === "Line") {
    _initializingSlider = true;
    $("#slider").labeledslider("option", "range", true);
    $("#slider").labeledslider("values", 0, _nSliderRangeMinValue);
    _initializingSlider = false;
    $("#slider").labeledslider("values", 1, _nSliderRangeMaxValue);
    showLabels(_nSliderRangeMinValue, _nSliderRangeMaxValue);
    rangeInit = true;
  } else {
    $("#slider").labeledslider("option", "range", false);

    if ($("#slider .ui-slider-handle").length > 1) {
      $($("#slider .ui-slider-handle")[1]).remove();
    }
    _nSliderValue = _nSliderValue > objRange.max ? _nSliderValue : objRange.max;
    if (rangeInit) {
      $("#slider").labeledslider("values", 0, _nSliderValue);
    } else {
      $("#slider").labeledslider("value", _nSliderValue);
    }
    showLabels(_nSliderValue, null);
  }
};

var showLabels = function(min, max) {
  var firstIndex;
  $(".ui-slider-label-ticks span").each(function(index, domElement) {
    var htmlValue = parseInt(domElement.innerHTML);
    if (statCompilerDashboard.getCurrentDisplayType() != "Line") {
      if (htmlValue === min) {
        $(".ui-slider-label-ticks").each(function(labelIndex, labelElement) {
          if (index == labelIndex) {
            $(labelElement).addClass("showYear");
          } else {
            $(labelElement).removeClass("showYear");
          }
        });
      }
    } else {
      if (htmlValue === min || htmlValue === min || htmlValue === max) {
        $(".ui-slider-label-ticks").each(function(labelIndex, labelElement) {
          if (htmlValue === min) {
            firstIndex = index;
          }
          if (index === labelIndex) {
            $(labelElement).addClass("showYear");
          } else if (labelIndex === firstIndex) {
            $(labelElement).addClass("showYear");
          } else {
            $(labelElement).removeClass("showYear");
          }
        });
      }
    }
  });
};

var addThisInit = function() {
  window.loadScriptAsync(
    "//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5543addf46fca71f",
    function() {
      if (window.addthis) {
        window.addthis.addEventListener(
          "addthis.menu.share",
          toggleShareWidget
        );
        window.addthis_config = window.addthis_config || {};
        window.addthis_config.data_track_clickback = false;
        updateShareURL();
      } else {
        throw new Error("Undefined Error: Could not init window.addThis");
      }
    }
  );
};

// var updateAddThisListener = function(){
//     window.addthis.removeEventListener();
//     window.addthis.addEventListener('addthis.menu.share', toggleShareWidget);
//     window.addthis_config = window.addthis_config || {};
//     window.addthis_config.data_track_clickback = false;
// }

// NOTE: this is a workaround as the api-specified way to do this fails, reference:
// http://stackoverflow.com/questions/15367134/change-addthis-url-dynamically-with-jquery
var updateAddThis = function(url) {
  if (url) {
    if (window.addthis) {
      addthis.update("share", "url", url.toString());
      addthis.url = url;
      // $(".addthis_sharing_toolbox").attr("data-url", "test.com");
      addthis.toolbox(".addthis_sharing_toolbox", null, {
        title:
          "STATcompiler: " +
          $("#indicatorName")
            .text()
            .toString(),
        url: url.toString()
      });
    }
  }
};

var updateShareURL = function() {
  // AddThis / Bitly URL shortening removed — sharing uses the long bookmark URL directly.
};

var testExport = function() {
  statCompilerDashboard.test();
};

window.temp = function() {
  // $('.at-svc-facebook span').trigger('click');
  // $('.at-svc-twitter span').trigger('click');
  $(".at-svc-twitter span").trigger("click");
};

var updateIndicatorName = function() {
  // alert("1046");
  var elementContainer = $(".indicatorName");
  var element = $("#indicatorName");
  // alert("1049");

  var condition = function() {
    var elementContainer = $(".indicatorName");
    var element = $("#indicatorName");
    return element.width() > Math.abs(elementContainer.width());
  };
  // alert("1054");

  var fit = function(text) {
    var words = text.split(" ");
    var spliceTarget =
      element.attr("title").length > 80
        ? Math.round(words.length / 2)
        : words.length - 1;
    words.splice(spliceTarget, 1);
    return words.join(" ");
  };
  // alert("1062");

  var truncate = function(text) {
    var words = text.split(" ");
    var replaceTarget =
      element.attr("title").length > 80
        ? Math.round(words.length / 2)
        : words.length - 1;
    words[replaceTarget] = "...";
    return words.join(" ");
  };
  // alert("1070");
  var initialCondition = condition();
  while (condition()) {
    element.text(fit(element.text()));
  }
  if (initialCondition) {
    element.text(truncate(element.text()));
  }
  //  alert("1079");
};

// Resize ui dialog for custom data popup

$(window).resize(function() {
  $("#customTable").setGridWidth(0.45 * $(window).width() - 30);
  $("div[aria-describedby='customPopup']").width(0.45 * $(window).width());

  var element = $("#indicatorName");
  element.text(element.attr("title"));
  updateIndicatorName();
});

var exportSliders = function() {
  $("#labelFontSize").labeledslider({
    max: 40,
    min: 0,
    value: 20,
    tickinterval: 1,
    slide: function(event, ui) {
      $(
        "#svgInnerContainer .highcharts-data-labels text, #svgInnerContainer .highcharts-data-labels text tspan"
      ).css("fontSize", ui.value + "px");
      $("#svgInnerContainer .highcharts-legend text").css(
        "lineHeight",
        ui.value + "px"
      );
      $("#svgInnerContainer .highcharts-data-labels text").attr(
        "x",
        -ui.value + 20
      );
    },
    change: function(event, ui) {}
  });

  $("#xAxisLabelFontSize").labeledslider({
    max: 22,
    min: 0,
    value: 20,
    tickinterval: 1,
    slide: function(event, ui) {
      $("#svgInnerContainer .highcharts-xaxis-labels text").css(
        "fontSize",
        ui.value + "px"
      );
      $(
        "#svgInnerContainer .highcharts-xaxis-labels text tspan:not(first-child)"
      ).attr("dy", ui.value);
    },
    change: function(event, ui) {
      $("#svgInnerContainer .highcharts-xaxis-labels text").css(
        "fontSize",
        ui.value + "px"
      );
    }
  });

  $("#legendFontSize").labeledslider({
    max: 22,
    min: 0,
    value: 20,
    tickinterval: 1,
    slide: function(event, ui) {
      $("#svgInnerContainer .highcharts-legend text").css(
        "fontSize",
        ui.value + "px"
      );
      $("#svgInnerContainer .highcharts-legend text").css(
        "lineHeight",
        ui.value + "px"
      );
    },
    change: function(event, ui) {
      $("#svgInnerContainer .highcharts-legend text").css(
        "fontSize",
        ui.value + "px"
      );
    }
  });

  $("#titleFontSize").labeledslider({
    max: 40,
    min: 10,
    value: 20,
    tickinterval: 1,
    slide: function(event, ui) {
      $("#svgInnerContainer .title text").css("fontSize", ui.value + "px");
      $("#svgInnerContainer .title text").css("lineHeight", ui.value + "px");
      $("#titlePDFChart").css("fontSize", ui.value + "px");
    },
    change: function(event, ui) {
      $("#svgInnerContainer .title text").css("fontSize", ui.value + "px");
      $("#titlePDFChart").css("fontSize", ui.value + "px");
    }
  });

  $("#customizeButton").click(function() {
    //$("#customizeButton").addClass("hidden")
    $("#multiSliderContainer").toggleClass("visibilyHidden");
    $("#slider-labels").toggleClass("visibilyHidden");

    var opacity = $("#slider-labels").hasClass("visibilyHidden") ? "0" : "1";

    $("#multiSliderContainer").css("opacity", opacity);
    $("#slider-labels").css("opacity", opacity);
  });

  $("#close").click(function() {
    $("#svg-container").addClass("hidden");
  });
};
